import isEmpty from 'lodash/isEmpty';
import isNil from 'lodash/isNil';
import capitalize from 'lodash/capitalize';
import get from 'lodash/get';
import { $can } from '@pendo/permissions';

export function convertSubscriptionPageRules (subscriptionPageRules) {
    const convertedArray = subscriptionPageRules.map(({ appId, uniqueRules }) => {
        const convertedUniqueRules = uniqueRules.map((rule) =>
            rule
                .replace(/\*parameter\*$/, '**')
                .replace(/\*parameter\*\?/, '**?')
                .replace(/\*parameter\*/, '*'),
        );

        return {
            appId,
            uniqueRules: convertedUniqueRules,
        };
    });

    return convertedArray;
}

export function filterOutPages (appFilter, rulesArr, state) {
    const appMap = get(state, 'apps.map', {});

    if (appFilter.includes('*')) {
        return rulesArr;
    }

    if (appFilter.includes('web') || appFilter.includes('extension')) {
        if (isEmpty(appMap)) {
            return [];
        }

        return rulesArr.filter((app) => {
            const appObj = appMap[app.appId];
            if (!appObj) return false;

            return get(appObj, 'platform', '') === appFilter[0];
        });
    }

    return rulesArr.filter((app) => appFilter.includes(app.appId));
}

export function removeSelectedPageRules (selections, suggestedPageRulesFilteredData) {
    const removeSet = new Set(selections.map((obj) => `${obj.appId}|${obj.rule}`));
    const updatedFilteredData = suggestedPageRulesFilteredData.filter(
        (obj) => !removeSet.has(`${obj.appId}|${obj.rule}`),
    );

    return updatedFilteredData;
}

export function canCreatePages (apps) {
    const canAppCreatePages = ([key]) =>
        $can(key)
            .entity('page')
            .action('create');

    return Object.fromEntries(Object.entries(apps).filter(canAppCreatePages));
}

export function generateSuggestedPageRules (event) {
    let rule;
    let name;
    let length;
    let sampleCount = 5;

    switch (event.suggestedRuleType) {
        case 'fragment':
            rule = `//*/**#${get(event, 'parseUrl.fragment', '')}`;
            name = capitalize(get(event, 'parseUrl.fragment', ''));
            break;
        case 'pathFragments':
            length = pathFragmentLength(get(event, 'samples[0]', ''));
            // using array constructor + join to get correct number of */ in rule
            rule = `//*/**#!/${new Array(event.itemIndex + 1).join('*/')}${get(event, 'parseUrl.pathFragments', '')}${
                event.itemIndex < length - 1 ? '/**' : ''
            }`;
            name = capitalize(get(event, 'parseUrl.pathFragments', ''));
            sampleCount = event.itemIndex === length - 1 ? 1 : 5;
            break;
        case 'paths':
            length = pathLength(get(event, 'samples[0]', ''));
            // using array constructor + join to get correct number of /* in rule
            rule = `//*${new Array(event.itemIndex + 1).join('/*')}/${event.parseUrl.path}${
                event.itemIndex < length - 1 ? '/**' : ''
            }`;
            // if the path is the last and we are collecting document_title we should use that for name
            name =
                event.itemIndex === length - 1 && !isNil(event.document_title)
                    ? get(event, 'document_title')
                    : capitalize(get(event, 'parseUrl.path'));
            sampleCount = event.itemIndex === length - 1 ? 1 : 5;
            break;
        case 'queryFragments':
            // fieldFragmentVals are decoded so we need to encode again for the rule
            rule = `//*/**#!/**?${event.fieldFragmentKeys}=${encodeURIComponent(event.fieldFragmentVals)}`;
            name = event.fieldFragmentVals || event.fieldFragmentKeys;
            break;
        case 'queryParameters':
            // fieldVals are decoded so we need to encode again for the rule
            rule = `//*/**?${event.fieldKeys}=${encodeURIComponent(event.fieldVals)}`;
            name = event.fieldVals || event.fieldKeys;
            break;
        default:
            rule = '';
            name = '';
            break;
    }

    return {
        rule,
        name,
        sampleCount,
    };
}

export function pathFragmentLength (sample) {
    const regexPathFragment = /^.*#!(.*$)/;
    const pathFragmentURL = sample.match(regexPathFragment)[1];
    const length = pathFragmentURL.split('/').length - 1;

    return length;
}

export function pathLength (sample) {
    const path = sample.split('//')[1].split('/');
    const length = path.length - 1;

    return length;
}
